import { withI18n } from '@lingui/react'
import { bool, shape, string } from 'prop-types'
import { type FunctionComponent } from 'react'

import { isRebrandingITActive } from 'shared/experiments/utils/rebranding'
import { type InferPropsWithDefaults } from 'shared/utils/propTypes'
import { i18nType } from 'views/utils/propTypes/i18nType'
import { usePageProperties } from 'views/utils/shopAndRuntimeConfigUtils'

const BonusColumn: FunctionComponent<ComponentProps> = ({
  i18n,
  useOTCMode,
  superScripts,
}) => {
  const bonusValue = useOTCMode ? superScripts.saving : superScripts.bonus
  const { experiments } = usePageProperties()
  const showSup = Boolean(bonusValue) && !isRebrandingITActive(experiments)
  // Locales builder doesn't pick this component so manual `i18n._` call used
  return (
    <>
      {useOTCMode
        ? i18n._('product.details.variants.savings.label')
        : i18n._('product.details.variants.bonus.label')}
      {showSup && <sup>{bonusValue}</sup>}
    </>
  )
}

const propTypes = {
  i18n: i18nType.isRequired,
  superScripts: shape({ saving: string, bonus: string }).isRequired,
  useOTCMode: bool,
}

const defaultProps = {
  useOTCMode: false,
}

type ComponentProps = InferPropsWithDefaults<
  typeof propTypes,
  typeof defaultProps
>

export default withI18n()(BonusColumn)
